import type { DevScenario } from '@arya/shared/domain';

import { INVEST_INSUFFICIENT_FUNDS_SCENARIO } from './invest-insufficient-funds.handler';
import { INVEST_RATE_LIMITED_SCENARIO } from './invest-rate-limited.handler';
import { INVEST_REFUSALS } from './invest-refusal.scenarios';
import { INVEST_SOURCE_OF_FUNDS_REQUIRED_SCENARIO } from './invest-source-of-funds-required.handler';
import { PROJECT_DETAIL_FAILURE_SCENARIO } from './project-detail-failure.handler';
import { PROJECT_NOT_LISTED } from './project-not-listed.scenario';

export const MARKET_PROJECT_SCENARIOS: readonly DevScenario[] = [
  PROJECT_DETAIL_FAILURE_SCENARIO,
  PROJECT_NOT_LISTED.scenario,
  INVEST_RATE_LIMITED_SCENARIO,
  INVEST_INSUFFICIENT_FUNDS_SCENARIO,
  INVEST_SOURCE_OF_FUNDS_REQUIRED_SCENARIO,
  ...INVEST_REFUSALS.map(({ scenario }) => scenario),
];
